@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;

.description {
  @include t.text(14px, 22px, 400);
  color: v.$palette-gray-900;
  margin-bottom: 24px;
}

.descriptionLink {
  @include t.text(14px, 22px, 600);
  color: v.$palette-blue;
  padding: 0;
}